import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import axios from 'axios'
import { setCompany } from 'store/auth/companySlice'
import { setPrinters } from 'store/auth/printerSlice'
function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    let { token, signedIn } = useSelector((state) => state.auth.session)
    const signIn = async (values) => {
        try {
            const resp = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/user/login`,
                values
            )
            if (resp.data.success) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                const headers = {
                    'x-order-token': token,
                }
                const result = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/user/viewProfile`,
                    { headers }
                )
                // console.log('result', result.data)
                if (result.data.data) {
                    dispatch(setUser(result.data.data))
                    dispatch(setCompany(result.data.company))
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const checkAuth = async () => {
        if (token) {
            const headers = {
                'x-order-token': token,
            }
            await axios
                .post(`${process.env.REACT_APP_API_URL}/api/user/isAuth`, '', {
                    headers,
                })
                .then((resp) => {
                    return true
                })
                .catch((err) => {
                    dispatch(onSignOutSuccess())
                    return false
                })
        } else {
            dispatch(setPrinters({ printers: [] }))
            dispatch(onSignOutSuccess())
            return false
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            
            if (resp.success) {
                return {
                    status: 'success',
                    message: 'Compte créé avec succès'
                }
            } else {
                return {
                    status: 'failed',
                    message: 'Réponse invalide du serveur'
                }
            }
        } catch (errors) {
            console.error('SignUp Error:', errors)
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        dispatch(setPrinters({ printers: [] }))
        dispatch(
            setCompany({
                image: '',
                name: '',
                type: '',
                reference: '',
                shift: {
                    start: '',
                    end: '',
                },
                features: [],
                printers: [],
            })
        )
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
        checkAuth,
    }
}

export default useAuth
